import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Field.st.css';
import { FieldProps } from './Field.types';
import { dataHooks } from '../../constants';

const Field = ({
  noPadding = false,
  divider = 'auto',
  children,
}: FieldProps) => {
  return (
    <div
      className={st(classes.root, {
        padded: !noPadding,
        divider: String(divider),
      })}
      data-hook={dataHooks.sidePanelField}
      data-hoverable-action-trigger
    >
      {children}
    </div>
  );
};

Field.displayName = 'Field';

Field.propTypes = {
  noPadding: PropTypes.any,
  divider: PropTypes.any,
  children: PropTypes.any,
};

export default Field;
